/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CopyConfigTemplate: BridgeCommands.Command<
    Types.Share.Forager.CopyConfigTemplateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Forager',
    method: 'CopyConfigTemplate',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ExtractFrames: BridgeCommands.Command<
    Types.Share.Forager.ExtractFramesParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Forager',
    method: 'ExtractFrames',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAppInfo: BridgeCommands.Command<
    {},
    Types.Share.Forager.GetAppInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Forager',
    method: 'GetAppInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const LaunchWithNativeApp: BridgeCommands.Command<
    Types.Share.Forager.LaunchWithNativeAppParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Forager',
    method: 'LaunchWithNativeApp',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ReadWorkspace: BridgeCommands.Command<
    Types.Share.Forager.ReadWorkspaceParameters,
    Types.Share.Forager.ReadWorkspaceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Forager',
    method: 'ReadWorkspace',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ReadFile: BridgeCommands.Command<
    Types.Share.Forager.ReadFileParameters,
    Types.Share.Forager.ReadFileReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Forager',
    method: 'ReadFile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SaveWorkspace: BridgeCommands.Command<
    Types.Share.Forager.SaveWorkspaceParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Forager',
    method: 'SaveWorkspace',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const TrimVideo: BridgeCommands.Command<
    Types.Share.Forager.TrimVideoParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Forager',
    method: 'TrimVideo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const WriteFile: BridgeCommands.Command<
    Types.Share.Forager.WriteFileParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Forager',
    method: 'WriteFile',
    persistent: false
};

export const Forager = {
CopyConfigTemplate,
ExtractFrames,
GetAppInfo,
LaunchWithNativeApp,
ReadWorkspace,
ReadFile,
SaveWorkspace,
TrimVideo,
WriteFile
};
